var s = {"content":"Modal_content_1uy5f_1"};

export { s as default };
//# sourceMappingURL=Modal.module.scss.js.map
